import { render, staticRenderFns } from "./CoreAlertSystem.vue?vue&type=template&id=05a43f94&"
import script from "./CoreAlertSystem.vue?vue&type=script&lang=js&"
export * from "./CoreAlertSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05a43f94')) {
      api.createRecord('05a43f94', component.options)
    } else {
      api.reload('05a43f94', component.options)
    }
    module.hot.accept("./CoreAlertSystem.vue?vue&type=template&id=05a43f94&", function () {
      api.rerender('05a43f94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Cores/CoreAlertSystem.vue"
export default component.exports